import axios from "axios";

export default function PricelistitemShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/price_list_item/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
